module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_bg.af30465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_bg.png
// module id = W3gb
// module chunks = 34